


























import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import AuthFormContainer from '@/components/modules/Auth/AuthFormContainer.vue';
import { masks } from '@/utils/plugins/inputMask';
import UiInput from '@/components/ui/UiInput.vue';
import UiLabel from '@/components/ui/UiLabel.vue';
import UiButton from '@/components/ui/UiButton.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { Profile } from '@/requests/mainApi';
import { formattingSecondsToStringTime } from '@/utils/helpers/helpFunctions';

interface Data {
  code: string;
  error: string | null;
  time: number;
  timer: any;
}

interface Methods {
  sendCode: (code: string) => void;
  setAccessToken: (accessToken: string) => void;
  confirmEmail: (data: { code: string }) => Promise<Profile>;
  startCountdown: () => void;
  formatTime: (time: number) => string;
  setIsFromConfirmEmail: (value: boolean) => void;
  registerProfile: (variables: AuthV1ProfileRegisterRequest) => Promise<Profile>;
  requestEmailConfirmCode: () => void;
  goBack: () => void;
}

interface Computed {
  temporaryAccessToken: string;
  activeButton: boolean;
  userData: Profile;
}

interface Props {}

export default Vue.extend({
  name: 'SignInEmailConfirmStep',
  components: {
    AuthFormContainer,
    UiInput,
    UiLabel,
    UiButton,
  },
  props: {},
  data() {
    return {
      code: '',
      error: null,
      time: 0,
      timer: null,
      masks,
    };
  },
  watch: {
    async code(value: string) {
      this.error = null;
      if (String(value).length === 4) {
        this.sendCode(value);
      }
    },
  },
  computed: {
    labelText() {
      return this.error ? this.error : this.$t('auth.signIn.emailConfirmStep.label');
    },
    activeButton() {
      return Boolean(this.time);
    },
    renewCodeButtonText() {
      return this.time
        ? `${this.$t('auth.signIn.emailConfirmStep.renewCode')} ${this.formatTime(this.time)}`
        : this.$t('auth.signIn.emailConfirmStep.repeatCode');
    },
    ...mapGetters(['temporaryAccessToken', 'userData']),
  },
  mounted() {
    this.startCountdown();
  },
  methods: {
    formatTime(time: number) {
      return time >= 0 ? formattingSecondsToStringTime(time, 'm:ss') : '0:00';
    },
    startCountdown() {
      this.time = 180;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async sendCode(code: string) {
      this.setAccessToken(this.temporaryAccessToken);
      try {
        const res = await this.confirmEmail({ code });

        console.log(res);
        // @ts-ignore
        if (!res.body?.isConfirmedEmail) {
          // @ts-ignore
          this.error = res.message || 'Неверный код';
          return;
        }
        this.$router.push('/');
      } catch (e) {
        console.log(e);
      }
    },
    requestEmailConfirmCode() {
      this.registerProfile({
        data: {
          email: this.userData.email,
          firstName: this.userData.firstName,
          lastName: this.userData.lastName,
          patronymic: this.userData.patronymic,
          birthday: this.userData.birthday,
        },
      }).then(() => {
        this.startCountdown();
      });
    },
    goBack() {
      this.setIsFromConfirmEmail(true);
      this.$emit('signUpStep');
    },
    ...mapActions(['confirmEmail', 'registerProfile']),
    ...mapMutations(['setAccessToken', 'setIsFromConfirmEmail']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
